import React, { Component } from 'react';
import { TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Table, TableHead, TableBody, Box, Button } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';

class SingleComReturn extends Component {
    state = { }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING ComReturn SINGLE ");
    }
    createProductList = () => {
        const { PRODUCTS, rea, shop } = this.props
        
        return rea.products.map( reaItem => {
            const prod = PRODUCTS[reaItem.product_id]
            
            return (
                <TableRow>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{reaItem.quantity}</TableCell>
                </TableRow>
            )
        })
    }
    
    render(){
        const { shop, commercial, rea } = this.props;
        return(
            <SingleTemplate
                shop={shop}
                commercial={commercial}
                sale={rea}
                notif={this.props.notif}
            >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createProductList()}
                        <TableRow>
                            <TableCell colSpan={2}></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>TRANSPORT</TableCell>
                            <TableCell>{rea.transport || 0}</TableCell>
                        </TableRow>
                    </TableBody>
                </TableLayout>
            </SingleTemplate>
        )
    }
}

export default SingleComReturn;